export enum PanelLayout {
	CREDITS_RIGHT,
	CREDITS_LEFT
};

export enum MessageType {
	PLAYER,			//normal player messages
	PLAYER_STATUS,  //join/left messages
	SYSTEM, 		//phase change and such messages
	SYSTEM_IMPORTANT//result message and other such important stuff
}
//----------Had to store volume settings somewhere, this seemed like a good place----------
export { musicVolume, effectsVolume, videoVolume, setMusicVolume, setEffectsVolume, setVideoVolume };
var musicVolume: number = 1.0;
var effectsVolume: number = 1.0;
var videoVolume: number = 1.0;
function setMusicVolume(value: number): void {
	musicVolume = value;
}
function setEffectsVolume(value: number): void {
	effectsVolume = value;
}
function setVideoVolume(value: number): void {
	videoVolume = value;
}

export { virtualWheel, setVirtualWheel }
var virtualWheel: boolean = false;
function setVirtualWheel(virtual: boolean) {
	virtualWheel = virtual;
}


export const Constants = {
	/*---------------DEV ONLY STUFF----------------*/
	DEVELOPER_MODE: false, // Local play without servers
	/*---------------------------------------------*/
	CONNECTION_RETRY_INTERVAL: 10000,
	SINGLE_ZERO_NUMBERS: [0, 32, 15, 19, 4, 21, 2, 25, 17, 34, 6, 27, 13, 36, 11, 30, 8, 23, 10, 5, 24, 16, 33, 1, 20, 14, 31, 9, 22, 18, 29, 7, 28, 12, 35, 3, 26],
	DOUBLE_ZERO_NUMBERS: [0, 28, 9, 26, 30, 11, 7, 20, 32, 17, 5, 22, 34, 15, 3, 24, 36, 13, 1, 37, 27, 10, 25, 29, 12, 8, 19, 31, 18, 6, 21, 33, 16, 4, 23, 35, 14, 2],
	CONVERGANCE_FACTOR: 0.3,
	BIG_WIN_LEVELS_THRESHOLDS: {
		BIG_WIN: 0.25,
		MEGA_WIN: 0.5,
		EPIC_WIN: 0.75
	},
	BIG_WIN_SENSITIVITY: {
		MULTIPLIER: 60,
		LIMIT: 20
	},
	SCENES: {
		LOAD: 'LOAD',
		MENU: 'MENU',
		GAME: 'GAME'
	},
	JACKPOT_TYPE: {
		LUCKY: "Lucky",
		PROGRESSIVE: "Progressive"
	},
	JACKPOT_LEVEL_STATUS: {
		DISABLED: "Disabled",
		COUNTING: "Counting",
		WON: "Won"
	},
	EVENTS: {
		MAIN_SCENE_READY: "mainReady",
		MAIN_SCENE_ACTIVE: "mainActive",
		CONN_ESTABLISHED: "connectionEstablished",
		PHASE_EVENT: "phaseEvent",
		WIN_NUMBER: "winNumber",
		PROGRESSBAR: "updateProgressBar",
		TOGGLE_RADIOBUTTONS: "toggleRadioButtons",
		SET_WIDE_BET: "setWideBet",
		SHOW_MESSAGE_BOX: "showMessageBox",
		TOGGLE_BOARD_HOTSPOTS: "toggleBoardHotSpots",
		TOGGLE_TRACK_HOTSPOTS: "toggleTrackHotSpots",
		TOGGLE_BOARD_HOTSPOTS_EFFECTS: "toggleBoardHotSpotsEffects",
		TOGGLE_TRACK_HOTSPOTS_EFFECTS: "toggleTrackHotSpotsEffects",
		TOGGLE_BOARD_TRACK_VIEW: "toggleBoardTrackView",
		TOGGLE_LAYOUT_SWITCH: "toggleLayoutSwitch",
		UPDATE_MAIN_TEXT: "updateMainText",
		HISTORY_UPDATE: "historyUpdate",
		HISTORY_UPDATE_NUMBER: "historyUpdateNumber",
		HISTORY_SAVED: "historySaved",
		PLAY_WIN: "playWin",
		PLACE_BET: "placeBet",
		CLIENT_CHIP_VALUE_CHANGE: "ClientOnChipValueChange",
		PANEL_UPDATE_BALANCE: "PanelUpdateBalance",
		UPDATE_SEND_BETS_TIME: "timeLeftForSendBets",
		UPDATE_GAME_ID: "updateGameId",
		FORCE_CLEAR_CHIPS: "forceClearChips",
		CLOSE_FORCED_MESSAGE_BOX: "closeForcedMessageBox",
		UPDATE_VIDEO_FEED_POSITIONS: "updateVideoFeedPositions",
		VIDEO_ZOOM_IN: "videoZoomIn",
		ADD_LOCK: "addLock",
		REMOVE_LOCK: "removeLock",
		BETS_OPENED: "betsOpened",
		ON_LOGOUT: "onLogout",
		STAKE_CHANGED: "stakeChanged",
		LATENCY_TOO_HIGH: "latencyTooHigh",
		CHAT_MESSAGE: "chatMessage",
		PLAYERS_CHANGE: "playersChange",
		CLICK_EVENT_FOR_CHAT_BOX: "clickEventOutsideInputField",
		WIN_REPORT: "winReport",
		BETS_CLOSED_TRIGGERED: "betsClosedTriggered",
		CHATBOX_TOGGLE: "chatboxToggle",
		SCENE_GLOBAL_POINTER_UP_EVENT: "pointerUpGlobal",
		SCENE_GLOBAL_POINTER_DOWN_EVENT: "pointerDownGlobal",
		VIRTUAL_WHEEL_RESPONSE: "virtualWheelResponse",
		VIRTUAL_WHEEL_TOGGLE_SPIN_BUTTON: "virtualWheelToggleSpinButton",
		VIRTUAL_DELAY_BALANCE: "virtualWheelDelayBalance",
		VIRTUAL_GAME_END: "virtualWheelGameEnd",
		VIDEOPOKER_BET_UPDATE: "vpBetUpdate",
		VIDEOPOKER_RESULT: "vpResult",
		VIDEOPOKER_RESULT_END: "vpEnd",
		MODULE_RELOAD: "moduleReload", //call this when a module gets added or removed
		JACKPOT_UPDATE: "jackpotUpdate",
		JACKPOT_WON: "jackpot-won",
		JACKPOT_WAS_WON: "jackpot-was-won",
		JACKPOT_STATE_LUCKY_NUMBER: "jackpotLuckyNumber",
		JACKPOT_STATE_LUCKY_LEVEL: "jackpotLuckyLevel",
		TOGGLE_HELP: "ToggleHelp",
		BET_SELECTED: "betSelected",
		CLEAR_ALL: "clearAll",
		LANGUAGE_CHANGED: "langChange",
		RENDER_HISTORY_VIEW: "historyView",
		TOGGLE_SHOW_MONEY: "toggleShowMoney",
		LES_FIGURES_WIN: "lesFiguresWin",
		AUTO_REPEAT: "autoRepeat",
		AUTO_RESOLVE: "autoResolve" //on game exit , client tries to autoresolve any active prompts if possible
	},
	YSERVER_MESSAGE_TYPES:
	{
		INIT: "init",
		ERROR: "error",
		EVENT: "event",
		QUESTION: "question",
		COOKIE: "cookie",
		PING: "ping"
	},
	CLIENT_MESSAGE_TYPES:
	{
		REQUEST: "request",
		PONG: "pong",
		TIMESYNC: "time"
	},
	CLIENT_REQUESTS:
	{
		AUTH: "authenticate",
		COMMIT_BETS: "bet",
		ACTION: "action",
		EVENTS: "events",
		PAYOUT: "payout",
		LOGOUT: "logout",
		EXIT: "exit",
		GOODBYE: "goodbye",
		PLAYER_LIST: "player-list",
		CANCEL_EXIT: "cancel-exit",
		SET_HELP_SCREENS: "set-help-screens",
		LOCK_ME: "station-lock",
		VOTE_START: "vote-start",
		CLIENT_STATUS: "client-status",
	},
	SERVER_EVENT_NAMES:
	{
		HISTORY: "history",
		GAME_STATE_CHANGED: "game-state-changed",
		WIN: "win",
		GAME_START: "game-round-start",
		BET: "bet",
		GAME_END: "game-round-end",
		BALANCE_UPDATE: "balance-update",
		VOID_EVENT: "void",
		AUTHENTICATION_REQUIRED: "authentication-required",
		LOCK: "lock",
		UNLOCK: "unlock",
		LOCK_CHANGED: "lock-changed",
		SESSION_EXPIRED: "session-expired",
		QUESTION: "question",
		STAKE_CHANGED: "stakeChanged",
		CHAT: "chat",
		PLAYER_JOINED: "player-joined",
		PLAYER_LEFT: "player-left",
		WIN_REPORT: "win-report",
		JACKPOT_WON: "jackpot-won",
		JACKPOT_WAS_WON: "jackpot-was-won",
		JACKPOT_UPDATE: "jackpot-update",
		MESSAGE: "message",
		ACCOUNT_END: "accounting-round-end",
		ACCOUNT_START: "accounting-round-start",
	},
	SERVER_GAME_STATE_CHANGED_TYPES:
	{
		PHASE: "phase",
		WIN_NUMBER: "winNumber",
		TIME_LEFT: "timeLeft",
		GAME_ID: "gameID",
		LUCKY_NUMBER: "jackpot.luckyNumber",
		LUCKY_LEVEL: "jackpot.luckyLevel",
		TOTAL_TIME: "totalTime"
	},
	ANIMATIONS: {
		COLD_ANIMATION: "ColdAnimation",
		HOT_ANIMATION: "HotAnimation",
		BALL_START: "BallStart",
		BALL_END: "BallEnd",
		BALL_SIM01: "BallSim01",
		BALL_SIM02: "BallSim02",
		BALL_SIM03: "BallSim03",
		BALL_SIM04: "BallSim04",
		HELPHAND: "helpHand",
	},
	SLOTATLAS: "slotatlas",
	SPRITESHEET: "boardsprites",
	SPRITESHEET_TRACK: "tracksprites",
	SPRITESHEET_TRACK_00: "track_00_sprites",
	SPRITESHEET_WINS: "WinAtlas",
	SPRITESHEET_IOS_TUTORIAL: "iOSTutorial",
	SPRITESHEET_MENU: "GameMenu",
	SPRITESHEET_STATISTICS: "statisticsAtlas",
	SPRITESHEET_BALL_DROPPED_ZOOM: "ballDroppedZoomSprites",
	SPRITESHEET_VIRTUAL_WHEEL: "spritsheetVirtualWheel",
	SPRITESHEET_GAME_BACKGROUND: "background",
	SPRITESHEET_LUCKY_NUMBER_JACKPOT_FIELD: "LuckyNumberJackpot",
	SPRITESHEET_JACKPOT_LEVEL_BACKGROUND: "JackpotPlayer",
	SPRITESHEET_JACKPOT_LUCKY_MARKER: "JackpotMarker",
	SPRITESHEET_PARTICLES: "Particles",
	SPRITESHEET_FIGURES: "theFigures",
	SPRITESHEET_FIGURES_BACKGROUND: "figuresBackground",
	LOADING_BACKGROUND: "loadingBackground",
	HISTORYBAR: "historyBar",
	IOS_INTRO_GAME_IMAGE: "iosIntroGameImage",
	COLORS: {
		BLACK: 0,
		RED: 1,
		GREEN: 3
	},
	LATERAL_BET_MODES:
	{
		LM_CAVALS_TRACK: 0,
		LM_FULL_WIDTH: 1,
	},
	BETS_DISPLAY:
	{
		CHIP_SIZE: 50,
		WINFALL_SPEED: 0.15,
		WIN_EXPLOSION_FORCE: 4e6,
		WIN_ROTATION_SPEED: 0.5,
	},
	HISTORIC_TWEEN:
	{
		DURATION: 300,
		TRANSITION: "0.3s filter linear, 0.3s -webkit-filter linear",
		GRAYSCALE: 40,
	},
	BET_CHIP_BUTTONS:
	{
		CHIP_FONT:
		{
			color: "#000",
			fontSize: "40px",
			fontStyle: "bold",
			fontFamily: "Arial"
		},
	},
	PROGRESS_BAR:
	{
		FONT: {
			fontFamily: "Arial",
			color: "white"
		},
		HISTORY_FIELD_FONT: {
			fontFamily: "Arial",
			color: "#262626"
		},
		INITIAL_STAGE_WIDTH: 250,
		BASE_HEIGHT: 35,
		BAR_COLOR: 0xCD9D37,
		BACKGROUND_COLOR: 0x000000,
		VIRTUAL_WHEEL_BETS_OPEN_COLOR: 0x5fd113,
		VIRTUAL_WHEEL_BETS_CLOSED_COLOR: 0xe32d19,
		RELATIVE_FONT_SIZE: 0.65,
		TIME_CONSTANT: 5
	},
	PRESETS_PANEL:
	{
		BUTTON_FONT:
		{
			fontFamily: "Arial",
			align: "center",
			wordWrap:
			{
				width: 30,
			},
			fontStyle: "bold",
		},
		NUMBER_OF_ROWS: 3,
		NUMBER_OF_COLUMNS: 4,
		BOARD_TEXTS_STYLE_FONT:
		{
			fontFamily: "Arial",
			align: "center",
			wordWrap:
			{
				width: 30
			},
			color: "#39280c",
			fontStyle: 'bold',
			fontSize: '22px',
		},
		TRACK_TEXTS_STYLE_FONT:
		{
			fontFamily: "Arial",
			align: "center",
			wordWrap:
			{
				width: 30
			},
			color: "#39280c",
			fontStyle: "bold",
			fontSize: '35px',
		},
		BACKGROUND_NAME: "presetsBackground"
	},
	PANEL:
	{
		LAYOUT: PanelLayout.CREDITS_RIGHT,
		MAX_CREDIT_TEXTS_HEIGHT: 0.5, // največ polovica višine enega gumba
		RELATIVE_BUTTON_SIZE: 0.75,
		INFO_ROWS_PER_BUTTON: 3.5,
		TEXT_WEIGHTS: {
			VOID_TEXT: 0.7, // VOID_TEXT: 0.6,
			DENOM_TEXT: 0.3, // DENOM_TEXT: 0.2,
			PLAYER_ID: 1
		},
		BUTTON_TINT:
		{
			SELECTED_TINT: 0xffdc1b,
			NORMAL_TINT: 0xababab,
		},
		TEXT_COLOR:
		{
			LOST: "#ff0000",
			WIN: "#00ff00",
			NORMAL: "#ffffff",
		},
		MISC_FONT:
		{
			fontFamily: "Arial",
			color: "#999999",
			fontSize: "40px",
		},
		CREDITS_FONT:
		{
			fontFamily: "Arial",
			color: "white",
			fontSize: "40px",
		},
		GAME_ID_FONT:
		{
			fontFamily: "Arial",
			color: "white",
			fontSize: "25px",
		},
		PLAYER_ID_FONT:
		{
			fontFamily: "Arial",
			color: "white",
			fontSize: "25px",
		},
		WIN_FONT:
		{
			fontFamily: "Arial",
			color: "white",
			fontSize: "30px",
		},
		BET_FONT:
		{
			fontFamily: "Arial",
			color: "white",
			fontSize: "30px",
		},
		LAYOUT_SWITCH_BUTTON_FONT:
		{
			fontFamily: "Arial",
			align: "center",
			wordWrap:
			{
				width: 30
			},
			fontStyle: "bold",
		},
		CHAT_BOX:
		{
			COLORS: {
				PLAYER_MESSAGE: "#ffd000", //yellow
				PLAYER_STATUS_MESSAGE: "#bf8600", //dead yellow
				SYSTEM_MESSAGE: "#008cff", //blue
				SYSTEM_IMPORTANT_MESSAGE: "#7fff00" //green
			}
		},
		ANIMATION_TIME: 1.5,
		MARGIN: 0.005,
		ELEMENT_SPACING: 0.015,
		LOCK_SCREEN_OPACITY: 0.7
	},
	MENU_BUTTON_STYLE_FONT:
	{
		fontFamily: "Arial",
		align: "left",
		color: "#ffffff",
		fontStyle: 'bold',
		fontSize: '22px',
	},
	QUESTION_STYLE_FONT:
	{
		fontFamily: "Arial",
		align: "center",
		color: "#ffffff",
		fontStyle: 'bold',
		fontSize: '22px',
	},
	MENU_BUTTON_STYLE_FONT_DISABLED:
	{
		fontFamily: "Arial",
		align: "left",
		color: "#8a8a8a",
		fontStyle: 'bold',
		fontSize: '22px',
	},
	LOADING_FONT:
	{
		fontFamily: "Arial",
		align: "center",
		color: "#ffffff",
		fontStyle: 'bold',
		fontSize: '40px',
	},
	VIDEO_FEED:
	{
		// After changing this aspect ratio, the dimensions (videoWidth, videoHeight) in VideoFeedStatic must be changed too <- WHYYYYY ???
		ASPECT_RATIO: 1.6,
		VIDEO_CONTAINER_NAME: "iframe_container",
		BCKG_IMAGE_CONTAINER_NAME: "iframe_container2",
	},
	ORIENTATION_WARNING:
	{
		FONT:
		{
			fontFamily: "Arial",
			color: "black",
			fontSize: "20px",
		},
		PHONE_WIDTH: 300,
		PHONE_HEIGHT: 600,
		DURATION: 3,
		TEXTURE_NAME: "orientation_warning_phone",
	},
	MESSAGE_BOX:
	{
		TWEEN:
		{
			TWEEN_DELAY: 1300,
			TWEEN_DURATION: 700,
			TWEEN_DELAY_FORCED: 4000,
		},
		WINDOW_HEIGHT: 100,
		TEXT_OFFSET: 1.10,
		WINDOW_BACKGROUND_COLOR: 0xffff00,
		FONT: {
			fontFamily: "Arial"
		}
	},
	CHIP:
	{
		FONT:
		{
			color: "#000",
			fontStyle: "bold",
		},
		FONT_SIZE: 40,
		FONT_NAME: "originalFontSize",
		PADDING: 0.25,
	},
	BOARD:
	{
		MAX_ALLOWED_BOARD_HEIGHT: 0.7,
		RELATIVE_SPACING_W: 0.03,
		RELATIVE_SPACING_H: 0.03,
		RELATIVE_SPACING_ZERO: 0.1,
		RELATIVE_SPACING_NUMBERS_ROW: 0.1,
		RELATIVE_SIDE_MARGIN: 0.005,
		MISC_BUTTON_NAMES:
		{
			REPEAT_BETS: "repeat_bets",
			SWITCH_LAYOUT: "switch_layout",
			NEIGHBOUR_BET: "neighbour_bet",
			UNDO_BET: "undo_bet",
		},
		MISC_BUTTON_FONT:
		{
			fontFamily: "Arial",
			align: "center",
			wordWrap:
			{
				width: 30
			},
			fontStyle: "bold",
			fontSize: "2em",
			resolution: 1,
		},
		BOARD_BUTTON_NAMES:
		{
			FIRST_THIRD: "1st12",
			SECOND_THIRD: "2nd12",
			THIRD_THIRD: "3rd12",
			ODD: "odd",
			EVEN: "even",
			RED: "red",
			BLACK: "black",
			FIRST_HALF: "1to18",
			SECOND_HALF: "19to36",
			TWELVE_ONE: "12to1",
			TWENTY_ONE_ONE: "22to1",
			THIRTY_TWO_ONE: "32to1"
		},
	},
	MAIN_SCENE:
	{
		MAX_SUPPORTED_RATIO: 3.6,
		BACKGROUND_COLOR: 0x08350c,
		CSS_BACKGROUND_COLOR: "#08350c",
		CLASS_NAME: "MainScene",
	},
	WIN_NUMBER_HISTORY:
	{
		MAX_INFO_PANEL_HEIGHT_TO_TAKE: 0.2,
		MAX_DISPLAYED_ITEMS: 25,
		OFFSET_FROM_FIRST_NUMBER: 0.35,
		HORIZONTAL_MARGIN: 0.5
	},
	LOAD_GAME:
	{
		ERROR_TEXT_FONT:
		{
			fontSize: "30px",
			color: "white",
		},
		PROGRESS_BAR:
		{
			BOX_HEIGHT: 50,
			BAR_HEIGHT: 30,
			BOX_COLOR: 0x222222,
			BOX_ALPHA: 0.8,
			BAR_COLOR: 0xffffff,
			BAR_ALPHA: 1
		},
	},
	TRACK:
	{
		HORIZONTAL_MARGIN: 1 / 12, // for the buttons
		TRACK_W_TO_H_RATIO: 2.64557,
		OFFSET_DUE_TO_ORIGIN: 57.5, // vertical offset in texture-space (half of the height of the numbers on the track)
		TEXTURE_ORIGINAL_WIDTH: 1463,
		MISC_BUTTON_NAMES:
		{
			RED_LEFT_TRACK: "red_left_track",
			RED_RIGHT_TRACK: "red_right_track",
			BLACK_LEFT_TRACK: "black_left_track",
			BLACK_RIGHT_TRACK: "black_right_track",
		},
		BET_NAMES:
		{
			ZERO_GAME: "zeroGame",
			BIG_SERIES: "bigSeries",
			ORPHANS: "orphans",
			SERIE_58: "serie58",
			LESFIGURES_NASSA: "lesFiguresNassa"
		},
		DEBUG_BUTTON_COLOR: 0xFF00FF,
		BLUE_COLOR: 0x0000FF,
	},
	CHIP_PAINTING:
	{
		TOUCH_DOWN:
		{
			INITIAL_OFFSET: 700,
			OFFSET: 200,
		},
	},
	DEMO_MODE:
	{
		FONT:
		{
			fontFamily: "Arial",
			fontSize: "20px",
			color: "white",
		},
	},
	BITMAP_FONTS: {
		MONTSERRAT: "montserrat"
	},
	SOUNDS: {
		WIN_1: "win1",
		WIN_2: "win2",
		WIN_3: "win3",
		JACKPOT_WIN: "jackpot_win",
		CHIP_SELECT: "chip_select",
		RADIOBTN_PRESS: "radiobtn_press",
		BET_CLEAR_CURRENT: "bet_clear_current",
		BET_PLACE_GROUP: "bet_place_group",
		BET_CLEAR_ALL: "bet_clear_all",
		BET_REPEAT: "bet_repeat",
		BETS_CLOSED: "bets_close",
		INTRO_TO_BACKGROUND_MUSIC: "intro_to_background_music",
		DEFAULT_BACKGROUND_MUSIC: "default_background_music",
		ALTERNATIVE_BACKGROUND_MUSIC: "alternative_background_music",
		BUTTON_PRESS_SOFT: "button_press_soft",
		BUTTON_PRESS: "button_press",
		VIEW_CHANGE: "view_change",
		SLIDER_CHANGE: "slider_change",
		PAYIN: "electronic_payin",
		PAYOUT: "electronic_payout",
		MENU_SELECT: "menu_select",
		MENU_VALIDATE: "menu_validate",
		CHIPS_DROPS: "Chips_Drops",
		FINANCIALS_CLICK: "VintageButton2",
		BET_PLACE_SINGLE_1: "chipSingle",
		BET_PLACE_SINGLE_2: "chipSingle2",
		BET_PLACE_SINGLE_3: "chipSingle3",
		BET_PLACE_SINGLE_4: "chipSingle4",
		BET_PLACE_SINGLE_5: "chipSingle5",
		BET_PLACE_MULTIPLE: "chipsMultiple",
	},
	VALUE_TO_CONSIDER_MAX_BET: 33333
};
